module.exports = __webpack_public_path__ + "static/media/downloadExcel.bed0038e.png";